import { FiTarget, FiAward, FiZap } from 'react-icons/fi';

export const studyPurposes = {
  exam: {
    id: "exam",
    title: "Prüfungsvorbereitung",
    description: "Maximale Sicherheit für die anstehende Klausur oder das Abitur.",
    icon: FiAward,
    intent: "Punktgenaue Performance und Stressresistenz in der Prüfungssituation.",
    focusPrefix: "Prüfungsrelevanz:"
  },
  university: {
    id: "university",
    title: "Studienvorbereitung",
    description: "Die Brücke zwischen Schulmathematik und Uni-Abstraktion schlagen.",
    icon: FiTarget,
    intent: "Tiefenverständnis und Vorbereitung auf formale Beweisführung und Logik.",
    focusPrefix: "Transfer-Fokus:"
  },
  sprint: {
    id: "sprint",
    title: "Zwischenspurt",
    description: "Lücken schließen, Grundlagen festigen und Noten nachhaltig verbessern.",
    icon: FiZap,
    intent: "Leistungsstabilisierung durch Schließen von Basislücken und Routineaufbau.",
    focusPrefix: "Lückenschluss:"
  }
};